import { put, call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import {
    IFetchScheduleInterviewAction,
    ISubmitScheduleInterviewAction,
} from '../redux/interface';
import { scheduleInterviewActions } from '../redux/scheduleInterviewSlice';
import {
    fetchScheduleInterviewApi,
    submitScheduleInterviewApi,
} from '../../apis/scheduleInterview';
import { SnackbarUtils } from '../../../common';
import i18next from 'i18next';

export function* fetchScheduleInterviewSaga(
    action: PayloadAction<IFetchScheduleInterviewAction>
) {
    try {
        const { token } = action.payload;
        const { response, error } = yield call(fetchScheduleInterviewApi, token);
        
        if (response?.status === 200) {
            const data = response.data;
            const hasNoSlots =
                !data.available_slots || data.available_slots.length === 0;
            if (data.error && hasNoSlots) {
                yield put(
                    scheduleInterviewActions.setScheduleInterviewError(
                        data.error
                    )
                );
            } else {
                yield put(
                    scheduleInterviewActions.setScheduleInterviewData({
                        data,
                    })
                );
            }
        } else {
            const errorMessage =
                error?.data?.error ||
                'Failed to load interview information.';
            yield put(
                scheduleInterviewActions.setScheduleInterviewError(
                    errorMessage
                )
            );
            yield call(SnackbarUtils.error, i18next.t('errors.generalError'));
        }
    } catch (error) {
        console.error('Fetch schedule interview error:', error);
        yield put(
            scheduleInterviewActions.setScheduleInterviewError(
                'Failed to load interview information.'
            )
        );
        yield call(SnackbarUtils.error, i18next.t('errors.generalError'));
    }
}

export function* submitScheduleInterviewSaga(
    action: PayloadAction<ISubmitScheduleInterviewAction>
) {
    try {
        const { token, date, time } = action.payload;
        const { response, error } = yield call(
            submitScheduleInterviewApi,
            token,
            date,
            time
        );

        if (response?.status === 200) {
            const successMessage =
                response.data?.message || 'Interview scheduled successfully!';
            yield call(SnackbarUtils.success, successMessage);
        } else {
            const errorMessage =
                error?.data?.error || i18next.t('errors.generalError');
            yield call(SnackbarUtils.error, errorMessage);
        }
    } catch (error) {
        console.error('Submit schedule interview error:', error);
        yield call(SnackbarUtils.error, i18next.t('errors.generalError'));
    } finally {
        yield put(scheduleInterviewActions.setSubmitScheduleInterviewDone());
    }
}
